<a href="#" @click="doSignout" @keypress.enter="doSignout" @keypress.space="doSignout">Sign out</a>